
const canMessageCurrentLeadTCPA = (_lead, conversations, agentNumber, leadNumber) => {
    if(!!!agentNumber && !!!leadNumber){
        return false
    }

    let filteredAgentNumber = String(agentNumber).replace(/\D/g, '')
    let filteredLeadNumber = String(leadNumber).replace(/\D/g, '')

    if(filteredAgentNumber.length === 10){
        filteredAgentNumber = `1${filteredAgentNumber}`
    }

    if(filteredLeadNumber.length === 10){
        filteredLeadNumber = `1${filteredLeadNumber}`
    }

    for (let i = 0; i < conversations.length; i++) {
        const entries = Object.entries(conversations[i])

        for (let j = 0; j < entries.length; j++) {
            const [_key] = entries[j]
            const data = atob(_key).split(':')

            let entryAgentPhone = data[0]?.replace(/\D/g, '')
            let entryLeadPhone = data[1]?.replace(/\D/g, '')

            if(entryAgentPhone.length === 10){
                entryAgentPhone = `1${entryAgentPhone}`
            }

            if(entryLeadPhone.length === 10){
                entryLeadPhone = `1${entryLeadPhone}`
            }

            if(entryAgentPhone === filteredAgentNumber && filteredLeadNumber === entryLeadPhone){
                return true
            }
        }
    }

    return false
}

export {canMessageCurrentLeadTCPA}